module.exports = __webpack_public_path__ + "static/media/sign-in-bg-375.7dfb005a.jpg";